export default "__VITE_ASSET__D0ej$$tb__"